import styled from 'styled-components';
import { ReactComponent as LogoImage } from '@/shared/svg/logo.svg?react';

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: fit-content;
  min-height: 50px;
  min-width: 50px;
  padding: 6%;
  background-color: ${({ theme }) => theme.colors.neutral.palette600};
  border-radius: ${({ theme }) => theme.radii.md}px;
  margin: ${({ theme }) => theme.spacing.lg}px auto;
`;

const Logo = ({ height = 24.76, width = 13.81 }: { height?: number; width?: number }) => (
  <LogoContainer>
    <LogoImage height={height} width={width} />
  </LogoContainer>
);

export default Logo;
